function getTelLink(phoneNumber) {
  var country = phoneNumber.country_code === '01' ? '1' : phoneNumber.country_code;
  var city = phoneNumber.phone_number.slice(0, 3);
  var number = phoneNumber.phone_number.slice(3, 10);
  return "tel:+".concat(country).concat(city).concat(number);
}
export default getTelLink;